// extracted by mini-css-extract-plugin
export default {"container":"ParticipantsContent_container__xtpEh","title":"ParticipantsContent_title__A+Xow"};